import type { Participant, StandingRow } from '@/data/types';

interface Props {
  standings: StandingRow[];
  participants: Participant[];
}

export function StandingsTable({ standings, participants }: Props) {
  const nameById = new Map(participants.map((p) => [p.id, p.displayName]));
  return (
    <div className="card-d" style={{ overflow: 'hidden' }}>
      <table className="tbl">
        <thead>
          <tr>
            <th style={{ width: 48 }}>#</th>
            <th>Участник</th>
            <th style={{ textAlign: 'right' }}>И</th>
            <th style={{ textAlign: 'right' }}>В</th>
            <th style={{ textAlign: 'right' }}>П</th>
            <th style={{ textAlign: 'right' }}>Разн. сетов</th>
            <th style={{ textAlign: 'right' }}>Очки</th>
          </tr>
        </thead>
        <tbody>
          {standings.map((s, idx) => (
            <tr key={s.participantId}>
              <td className="num t-mute">{idx + 1}</td>
              <td>{nameById.get(s.participantId) ?? s.participantId}</td>
              <td className="num" style={{ textAlign: 'right' }}>{s.played}</td>
              <td className="num" style={{ textAlign: 'right' }}>{s.wins}</td>
              <td className="num" style={{ textAlign: 'right' }}>{s.losses}</td>
              <td className="num" style={{ textAlign: 'right' }}>
                {s.setDiff > 0 ? `+${s.setDiff}` : s.setDiff}
              </td>
              <td className="num" style={{ textAlign: 'right', fontWeight: 600 }}>{s.points}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
